import { Directive, Input } from '@angular/core';

/** A cute little directive that sets the tracking area for a given component tree.
 * Descendant components can inject the contextual instance to get the tracking area for calls to {@link TrackerService}.
 */
@Directive({ selector: '[dgxTrackingArea]' })
export class TrackingAreaDirective {
  @Input('dgxTrackingArea') public area: string;
}
